import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { CustomTooltipComponent } from '../components/custom-tooltip/custom-tooltip.component';

@Directive({
  selector: '[customTooltip]',
})
export class CustomTooltipDirective {
  @Input('customTooltipTitle') title!: string;
  @Input('customTooltipSubtitle') subtitle!: string;

  private overlayRef?: OverlayRef;

  constructor(private overlay: Overlay, private elementRef: ElementRef) {}

  @HostListener('mouseenter')
  show() {
    this.overlayRef = this.overlay.create({
      positionStrategy: this.overlay
        .position()
        .flexibleConnectedTo(this.elementRef)
        .withPositions([{ originX: 'center', originY: 'bottom', overlayX: 'center', overlayY: 'top', offsetY: 8 }]),
      scrollStrategy: this.overlay.scrollStrategies.reposition(),
      hasBackdrop: false,
    });

    const tooltipPortal = new ComponentPortal(CustomTooltipComponent);
    const tooltipRef = this.overlayRef.attach(tooltipPortal);

    tooltipRef.instance.title = this.title;
    tooltipRef.instance.subtitle = this.subtitle;
  }

  @HostListener('mouseleave')
  hide() {
    this.overlayRef?.dispose();
  }
}
